// extracted by mini-css-extract-plugin
export var linkText = "_p6-0";